// extracted by mini-css-extract-plugin
module.exports = {"heading":"TermsOfServicePage_heading__tMCnn","content":"TermsOfServicePage_content__jU0sX"};